import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AxiosCustomGet, AxiosCustomPost } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import Title from "../../../components/common/Title/Title";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { Upload, Button, message } from "antd";
import { FaLongArrowAltDown } from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";
import { convertEmployee } from "../helpers/convertEmployee";
import { useHistory } from "react-router-dom";
import AppRoutePath from "../../../router/AppRoutePath";
import moment from "moment";
import IsEmpty from "../../../components/helpers/IsEmpty";

const ExclusiveAdd = () => {
    const history = useHistory()
    const [loading, setLoading] = useState(false);
    const [photoKtp, setPhotoKtp] = useState([]);
    const [photoKtpPath, setPhotoKtpPath] = useState('');
    const [form, setForm] = useState({});
    const [listEmployee, setListEmployee] = useState({});
    const [errors, setErrors] = useState({});
    const [fromNik, setFromNik] = useState(false);

    useEffect(() => {
        getDataMaster()
    }, []);


    const getDataMaster = () => {
        setLoading(true);
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/exclusive/master-data`;
        AxiosCustomGet(url, Config({ Authorization: `Bearer ${Cookies.get("access_token")}` }),
            (response) => {
                setLoading(false);
                setListEmployee(convertEmployee(response.data.data.employees))
            },
            (error) => {
                setLoading(false);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const handleEnter =
        (type = "enter") =>
            (event) => {
                if (event.keyCode === 13 || type === "blur") {
                    getCustomerByNik()
                }
            };

    const getCustomerByNik = () => {
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/exclusive/customer-ktp/${form.nik}`;
        AxiosCustomGet(url, Config({ Authorization: `Bearer ${Cookies.get("access_token")}` }),
            (response) => {
                let data = response.data.data
                setForm((prev) => ({
                    ...prev,
                    name: data.ktp_name,
                    ktp: data.ktp_picture,
                    phone: data.phone_1,
                    birthdate: new Date(data.birth_date),
                    gender: data.gender,
                    email: data.email,
                    address: `${data.address} ${data.village} ${data.subdistrict} ${data.province}`,
                }))
                setFromNik(true)
            },
            (error) => {
                setFromNik(false)
            }
        );
    };

    const dragPhoto = {
        name: "file",
        multiple: false,
        onChange(info) {
            handleUploadImage(info.file)
        },
    };

    const handleUploadImage = (file) => {
        const fmData = new FormData();
        fmData.append("file", file);

        let url = `${process.env.REACT_APP_BASE_API_URL}upload-image`;
        AxiosCustomPost(
            url,
            fmData,
            Config({
                Authorization: `Bearer ${Cookies.get("access_token")}`,
                "content-type": "multipart/form-data",
            }),
            (response) => {
                message.success('uploaded');
                setPhotoKtp([file])
                setForm((prev) => ({
                    ...prev,
                    ktp: response.data.data.object_path,
                }));
            },
            (error) => {
                console.log(error.response.data)
                message.error('error');
            }
        );
    };

    const onChangeInput = (e) => {
        const { name, value } = e.target
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    }
    const onChangeDate = (e) => {
        setForm((prev) => ({
            ...prev,
            birthdate: e,
        }));
    }
    const onChangeSelect = (e) => {
        setForm((prev) => ({
            ...prev,
            officer: e,
        }));
    }

    const validate = () => {
        const newErrors = {};

        if (IsEmpty(form.ktp)) {
            newErrors.ktp = "Foto KTP harus di upload";
        }
        if (IsEmpty(form.nik)) {
            newErrors.nik = "NIK tidak boleh kosong";
        }
        if (IsEmpty(form.name)) {
            newErrors.name = "Nama tidak boleh kosong";
        }
        if (IsEmpty(form.birthdate)) {
            newErrors.birthdate = "Tanggal lahir tidak boleh kosong";
        }
        if (IsEmpty(form.gender)) {
            newErrors.gender = "Jenis Kelamin tidak boleh kosong";
        }
        if (IsEmpty(form.phone)) {
            newErrors.phone = "No. Telepon tidak boleh kosong";
        }
        if (IsEmpty(form.address)) {
            newErrors.address = "Alamat tidak boleh kosong";
        }
        if (IsEmpty(form.officer)) {
            newErrors.officer = "Officer harus dipilih";
        }
        return newErrors;
    };


    const onSubmit = () => {
        const newErrors = validate();

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
        } else {
            let data = {
                ktp_name: form.name,
                ktp_number: form.nik,
                ktp_picture: form.ktp,
                phone_1: form.phone,
                phone_2: " ",
                birth_date: moment(form.birthdate).format('YYYY-MM-DD'),
                gender: form.gender,
                email: form.email,
                address: form.address,
                assigned_employee_id: form.officer.value
            }
            setLoading(true);
            let url = `${process.env.REACT_APP_BASE_API_URL}gadai/exclusive`;
            AxiosCustomPost(url, data, Config({ Authorization: `Bearer ${Cookies.get("access_token")}` }),
                (response) => {
                    history.push(AppRoutePath.EXCLUSIVE_LIST)
                },
                (error) => {
                    console.log(error.response.data)
                    setLoading(false);
                    if (error.response) {
                        SwalToast.fire({
                            icon: "error",
                            title: error.response.data.error.message,
                        });
                    } else {
                        SwalToast.fire({
                            icon: "error",
                            title: "Whoops, something went wrong",
                        });
                    }
                }
            );
        }
    }
    return (
        <div className="px-3">
            <div>
                <div className="py-4 d-flex">
                    <div>
                        <Title text={"Buat Gadai Eksklusif"} />
                        <Breadcrumb current={"Buat Gadai Eksklusif"} />
                    </div>
                </div>
            </div>
            <div className="p-3 bg-white shadow-graph rounded mx-auto">
                <div className="d-flex flex-column" style={{ fontSize: 14 }}>
                    <h7 className="font-weight-semi-bold">Isi Data Nasabah & Pilih Officer</h7>
                    <h7 className="pt-3 color-303030">Upload Foto KTP</h7>
                    <Upload.Dragger
                        disabled={fromNik}
                        {...dragPhoto}
                        beforeUpload={() => false}
                        fileList={photoKtp}
                        className="p-3"
                    >
                        <p className="ant-upload-drag-icon">
                            <FaLongArrowAltDown style={{ fontSize: 40, color: "#F5CB58" }} />
                        </p>
                        <p className="ant-upload-text font-weight-bold">
                            Tarik dan letakkan file disini
                        </p>
                        <p className="ant-upload-hint">atau</p>
                        <p className="ant-upload-hint">
                            <Button
                                disabled={fromNik}
                                style={{
                                    margin: "5px",
                                    border: "0.75px solid #DCDCDC",
                                    borderRadius: 6,
                                }}
                            >
                                Pilih Foto
                            </Button>
                        </p>

                        <p className="ant-upload-hint">Format jpg/png</p>
                    </Upload.Dragger>
                    <label className="small text-danger">{errors.ktp}</label>
                    <div className="d-flex flex-row" style={{ fontSize: 14 }}>
                        <div className="form-group p-1 mt-1 col-4">
                            <label htmlFor="first_name" className="color-303030">
                                NIK
                            </label>
                            {/* <TextInput
                                id={"nik"}
                                label={"NIK"}
                                width={"100%"}
                                handleEnter={handleEnter}
                                value={form.nik}
                                handleChange={onChangeInput}
                            /> */}
                            <input
                                name="nik"
                                className="form-control"
                                value={form.nik}
                                onChange={onChangeInput}
                                onKeyDown={handleEnter("enter")}
                                onBlur={handleEnter("blur")}
                            />
                            <label className="small text-danger">{errors.nik}</label>
                        </div>
                        <div className="form-group p-1 mt-1 col-4">
                            <label htmlFor="last_name" className="color-303030">
                                Nama Sesuai KTP
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                value={form.name}
                                onChange={onChangeInput}
                            />
                            <label className="small text-danger">{errors.name}</label>
                        </div>
                        <div className="form-group p-1 mt-1 col-4">
                            <label htmlFor="date_of_birth" className="color-303030">
                                Tanggal Lahir
                            </label>
                            <div className="d-flex align-items-center">
                                <DatePicker
                                    name="birthdate"
                                    dateFormat="yyyy-MM-dd"
                                    selected={form.birthdate}
                                    onChange={onChangeDate}
                                    className="form-control"
                                    value={form.birthdate}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                                <IoCalendarOutline
                                    style={{ fontSize: 20, marginLeft: -30, zIndex: 1 }}
                                />
                            </div>
                            <label className="small text-danger">{errors.birthdate}</label>
                        </div>
                    </div>

                    <div className="d-flex flex-row" style={{ fontSize: 14 }}>
                        <div className="form-group p-1 mt-1 col-4">
                            <label htmlFor="gender" className="color-303030">
                                Jenis Kelamin
                            </label>
                            <div id="gender" className="" style={{ fontSize: 16 }}>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="gender"
                                        id="inlineRadio1"
                                        onChange={onChangeInput}
                                        value="L"
                                        checked={form.gender === "L"}
                                    />
                                    <label className="small form-check-label" for="inlineRadio1">
                                        Laki-laki
                                    </label>
                                </div>
                                <div className="small form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="gender"
                                        id="inlineRadio2"
                                        onChange={onChangeInput}
                                        value="P"
                                        checked={form.gender === "P"}
                                    />
                                    <label className="form-check-label" for="inlineRadio2">
                                        Perempuan
                                    </label>
                                </div>
                                <label className="small text-danger">{errors.gender}</label>
                            </div>
                        </div>
                        <div className="form-group p-1 mt-1 col-4">
                            <label htmlFor="phone" className="color-303030">
                                No. Telepon
                            </label>
                            <input
                                type="phone"
                                name="phone"
                                className="form-control"
                                value={form.phone}
                                onChange={onChangeInput}
                            />
                            <label className="small text-danger">{errors.phone}</label>
                        </div>
                        <div className="form-group p-1 mt-1 col-4">
                            <label htmlFor="email" className="color-303030">
                                Email (Optional)
                            </label>
                            <input
                                type="text"
                                name="email"
                                className="form-control"
                                value={form.email}
                                onChange={onChangeInput}
                            />
                        </div>
                    </div>
                    <div className="d-flex flex-row" style={{ fontSize: 14 }}>
                        <div className="form-group p-1 mt-1 col-12">
                            <label htmlFor="address" className="color-303030">
                                Alamat Sesuai KTP
                            </label>
                            <input
                                type="text"
                                name="address"
                                className="form-control"
                                value={form.address}
                                onChange={onChangeInput}
                            />
                            <label className="small text-danger">{errors.address}</label>
                        </div>
                    </div>
                    <div className="d-flex flex-row" style={{ fontSize: 14 }}>
                        <div className="form-group p-1 mt-1 col-4">
                            <label htmlFor="outlet" className="color-303030">
                                Pilih Officer
                            </label>
                            <Select
                                name="officer"
                                options={listEmployee}
                                onChange={onChangeSelect}
                                value={form.officer}
                            />
                            <label className="small text-danger">{errors.officer}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex p-3">
                <div className="ml-auto">
                    <button
                        onClick={() => history.goBack()}
                        className="ml-3 btn text-2C465C px-5"
                        style={{ borderWidth: 1, borderColor: '#DCDCDC' }}
                        type="submit">
                        Kembali
                    </button>
                    <button
                        onClick={onSubmit}
                        disabled={loading}
                        className="ml-3 btn border-438EBC bgc-2C465C text-white px-5"
                        type="submit">
                        Buat Gadai
                    </button>
                </div>
            </div>
        </div >
    );
};

export default ExclusiveAdd;
